import { useMutation } from '@northladder/services';
import { IApiError } from '@northladder/utilities';

import { COSMETIC_EVALUATION_API } from '../cosmeticEvaluationClient';
import { IDeviceAssessmentResultsResponseData } from '../types';

/**
 * Tracks cached data for the device assessment in react query cache.
 */
const MUT_DEVICE_ASSESSMENT_RESULTS_KEY =
  'device-assessment-results-mutation-key';

interface IUseDeviceAssessmentResultsOptions {
  onSuccessCallback: (
    responseData: IDeviceAssessmentResultsResponseData
  ) => void;
  onErrorCallback: (err: IApiError) => void;
}

/**
 * This query performs the post request that submits the results from the device
 * assessment session.
 * - https://northladder.atlassian.net/wiki/spaces/BTS/pages/2472378369/Used+Device+Trade-In+Integration+for+Pandas+WebApp#Post-Results-%26-Return-Redirect-URL
 */
export const useDeviceAssessmentResultsMutation = ({
  onSuccessCallback,
  onErrorCallback,
}: IUseDeviceAssessmentResultsOptions) => {
  const { mutate, isPending, error } = useMutation({
    mutationKey: [MUT_DEVICE_ASSESSMENT_RESULTS_KEY],
    networkMode: 'always',
    retry: false,
    mutationFn: COSMETIC_EVALUATION_API.submitDeviceAssessmentResults,
    onSuccess: (responseData) => {
      onSuccessCallback(responseData);
    },
    onError: (err: IApiError) => {
      onErrorCallback(err);
      return err;
    },
  });

  return {
    error,
    isPending,
    submitAssessmentResults: mutate,
  };
};
